import "./styles/style.less";
import {Flex} from "antd";
import {Outlet} from "react-router";

export default function AdmissionPage() {

    return (
        <Flex className={"admission-page"} vertical={true} align={"stretch"} gap={16}>
            <Outlet/>
        </Flex>
    )
}